import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
        light: {
            secondary: '#22b74f',
            primary: '#294c9e'
        }
        }
    }
});
